<template>
	<div class="form flex">

		<form-input
			:source="$root.source === 'enel' ? 'enel' : 'default'"
			full
			param="name"
			:inputAttr="{ autocomplete: 'name', type: 'text' }"
			v-show="enabled.indexOf('name') !== -1"
		/>

		<form-input
			v-if="!$root.config.googlePlaces"
			full
			param="street"
			:inputAttr="{ autocomplete: 'shipping street-address', type: 'text' }"
			v-show="enabled.indexOf('street') !== -1 && $root.source !== 'enel' "
		/>

        <google-places-input
        	v-if="$root.config.googlePlaces"
					v-show="enabled.indexOf('street') !== -1  && $root.source !== 'enel' "
        />

       <!--  <div
        	class="red-text full"
        	v-if="!isAddressCompleted"
        >
        	L'indirizzo potrebbe non essere completo – verifica i dettagli indirizzo.
        	
        </div> -->

     <!--    <template
      		v-if="!showAddressInput"
      	>
        	<div
        		class="backgrounded"
        		v-if="subscriptionStore.subscriptionParams.street"
        	>
        		<div>
        			<b>Dettagli indirizzo:</b><br>
        			{{ subscriptionStore.subscriptionParams.street }}<br>
        			<span
        				v-if="subscriptionStore.subscriptionParams.zip_code"
        			>
        				{{ subscriptionStore.subscriptionParams.zip_code }},
        			</span>
        			{{ subscriptionStore.subscriptionParams.city }}
        		</div>

	        	<div
	        		@click="showAddressInput = true"
	        		class="link-detail"
	        	>
	        		Modifica
	        	</div>
	        </div>

	        <div
	        	v-if="!subscriptionStore.subscriptionParams.street"
	        	class="link-detail address full"
	        	@click="showAddressInput = true"
	        >
	        	Inserisci l'indirizzo manualmente
	        </div>
        </template> -->

	    <template
	    
	    >
	    <!-- 	<form-input
				v-if="$root.config.googlePlaces"
				full
				param="street"
				:inputAttr="{ autocomplete: 'shipping street-address', type: 'text' }"
				v-show="enabled.indexOf('street') !== -1"
			/> -->

			<form-input
				param="zip_code"
				:inputAttr="{ autocomplete: 'shipping postal-code', type: 'tel', placeholder: $t('components.subscription_form.default.zip_code') }"
				v-show="enabled.indexOf('zip_code') !== -1  && $root.source !== 'enel' "
			/>

			<form-input
				type="select"
				param="city"
				:options="cities"
				@onChange="onChangeCity($event)"
				:inputAttr="{ placeholder: $t('components.subscription_form.default.choose_city') }"
				v-show="enabled.indexOf('city') !== -1  && $root.source !== 'enel' "
			/>
		</template>

		<!-- <form-input
			v-if="$root.config.vuePhone"
			type="vue-phone"
			param="telephone"
		/> -->

		<form-input
			:inputAttr="{ maxlength: 15, autocomplete: 'tel', type: 'number' }" 
			param="telephone"
			v-show="enabled.indexOf('telephone') !== -1  && $root.source !== 'enel' "
		/>

		<form-input
				v-if="$root.source === 'enel'"
				param="regione"
				type="select"
				:options="regions"
				:inputAttr="{ placeholder: subscriptionStore.subscriptionParams['message'] }"
				@onChange="onChangeRegion($event)"
			/>

		<form-input
			v-else
			ref="messageForm"
			param="message"
			:inputAttr="{ maxlength: 45, title: 'max 45', type: 'text', placeholder: $t('components.subscription_form.default.placeholder_message') }"
			v-show="enabled.indexOf('message') !== -1"
		/>

		<v-checkbox 
			v-if="enabled.indexOf('message') !== -1 && subscriptionStore.shipment_type === 'milkmanfresh'"
			v-model="checkbox"
			class="pa-0 ma-0 ml-auto" 
			:ripple="false" 
			hide-details="true" 
			color="var(--quomi-primary)" 
			label="Consegna al piano"
			@click="triggerFloorDelivery"
		/>
	</div>
</template>

<script>
import { subscriptionStore } from '../../store/subscriptionStore'
import { orderStore } from "../../store/orderStore"

import FormInput from "./FormInput"
import GooglePlacesInput from "./GooglePlacesInput"

import { CitiesApi } from '../../api/CitiesApi'

import { deliveryContainer } from '../../mixins/deliveryContainer'

export default {
	data () {
		return {
			cities: null,
			orderStore: orderStore.state,
			subscriptionStore: subscriptionStore.state,
			checkbox: false,
			checkWord: 'Consegna al piano, ',
			regions: [
				'Emilia Romagna',
				'Friuli Venezia Giulia',
				'Liguria',
				'Lombardia',
				'Marche', 
				'Piemonte',
				'Sardegna',
				'Sicilia',
				'Toscana',
				'Trentino Alto Adige',
				'Umbria',
				'Veneto'
			]
/* 		showAddressInput: true,
			isAddressCompleted: true */
		}
	},

	props: {
		enabled: {
			type: Array,
			default: ['street', 'city', 'zip_code']
		}
	},
	components: {
		FormInput,
		GooglePlacesInput
	},

	mixins: [
		deliveryContainer
	],

	watch: {
		'subscriptionStore.subscriptionParams.zip_code': 'onChangeZip',
		'subscriptionStore.subscriptionParams.message': 'onChangeMessage'
	},

	methods: {
		loadCitiesByZip () {
			var zip = this.subscriptionStore.subscriptionParams.zip_code

			return this.getCitiesByZip(zip)

			.then(response => {
				this.cities = response
			})
		},

		getCitiesByZip (zip) {
			if (!zip || zip.length < 5) {
				subscriptionStore.updateSubscriptionParam({ param: 'city', value: '' })
				return Promise.resolve()
			}

			var cm = new CitiesApi()
			return cm.get({
				zip_code: zip
			})

			.then(response => {
				return response.body.data.resources
			})
		},

		onChangeZip ($event) {
			
			orderStore.updateOrderParam({ param: 'shipment_zone_id', value: null })
			this.loadCitiesByZip()

			.then(response => {
				this.$_deliveryContainer_loadDeliveries()
			})
			
		},

		onChangeCity ($event) {
			subscriptionStore.updateSubscriptionParam({ param: 'city', value: $event.target.value })
			orderStore.updateOrderParam({ param: 'shipment_zone_id', value: null })
			this.$_deliveryContainer_loadDeliveries()
		},

		onChangeMessage($event) {
			if($event && $event.includes(this.checkWord)) {
				this.checkbox = true
			} else {
				this.checkbox = false
			}
		},

		onChangeRegion($event) {
			subscriptionStore.updateSubscriptionParam({ param: 'message', value: $event.target.value })
		},

		triggerFloorDelivery() {
			if(this.checkbox) {
			if(!this.subscriptionStore.subscriptionParams['message'].includes(this.checkWord))	{
				this.$refs.messageForm.updateSubscriptionParam({ param: 'message', value: this.checkWord + this.subscriptionStore.subscriptionParams['message']})
			}
			} else {
				return this.$refs.messageForm.updateSubscriptionParam({ param: 'message', value: this.subscriptionStore.subscriptionParams['message'].replace(this.checkWord, "")});
			}
		}
	},

	mounted () {
		if(this.subscriptionStore.subscriptionParams['message'] === null) {
			this.subscriptionStore.subscriptionParams['message'] = ""
		}
		this.onChangeMessage(this.subscriptionStore.subscriptionParams['message']) 
		this.loadCitiesByZip()
	}
}

</script>

<style scoped>
.form {
	flex-wrap: wrap;
	text-align: left;
	margin: 0 -5px;
}

.form >>> label {
	flex-basis: 50%;
	padding: 0 5px;
}

.form >>> .full {
	flex-basis: 100%;
}

.form .backgrounded {
	background-color: #ededed;
	padding: 10px;
	margin: 5px 5px 15px 5px;
	flex-basis: 100%;
}

.red-text {
	margin: 0 5px 0 5px;
}

.address {
	margin: 0px 5px 20px 5px;
}

/**/
@media (max-width: 700px) {
	.form >>> label {
		flex-basis: 100%;
	}
}

</style>
